var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropzoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 13.3999V22.9999C1.3335 23.6364 1.61445 24.2469 2.11454 24.697C2.61464 25.147 3.29292 25.3999 4.00016 25.3999H20.0002C20.7074 25.3999 21.3857 25.147 21.8858 24.697C22.3859 24.2469 22.6668 23.6364 22.6668 22.9999V13.3999M17.3335 6.1999L12.0002 1.3999M12.0002 1.3999L6.66683 6.1999M12.0002 1.3999V16.9999",
    stroke: "#94C11F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropzoneIcon);
export default __webpack_public_path__ + "static/media/DropzoneIcon.dcde2cb85d8b6e8ed94ef35878e2ccd2.svg";
export { ForwardRef as ReactComponent };